<template>
<!-- 通知公告 -->
    <div class="notify">
        <!-- 头部 -->
        <navbar-header></navbar-header>
        <!-- 背景层 -->
        <div class="bg_box"></div>
        <!-- 内容 -->
        <notify-list></notify-list>
        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
import NavbarHeader from '@/components/index/NavbarHeader'
import NotifyList from '@/components/notify/NotifyList'
import NavFooter from '@/components/common/NavFooter'
    export default {
        components: {
            NavbarHeader,
            NotifyList,
            NavFooter,
        },
    }
</script>

<style lang="scss" scoped>
.notify {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 269px;
        z-index: -1;
    }
}
</style>